// Category slug -> permanent canonical hub route.
// Used to eliminate crawlable /services?category=... URLs from the site.
// If a category has no dedicated hub, it falls back to /services.
export const CATEGORY_TO_HUB = {
  "strategy-and-audits": "/services",
  "brand-systems": "/services/brand",
  "website-systems": "/services/websites",
  "brand-and-website-packages": "/services",
  "local-visibility": "/services/marketing",
  "content-and-social": "/services/marketing",
  "print-and-sales-materials": "/services/print-sales-materials",
  "digital-product-support": "/services",
  "platform-brand-kits": "/services",
  "marketing-support": "/services/marketing",
  "business-launch-support": "/services",
  "custom-projects": "/services",
  // Aliases retained from older link data.
  brand: "/services/brand",
  website: "/services/websites",
  "sales-materials": "/services/print-sales-materials",
};

export const categoryHref = (slug) => CATEGORY_TO_HUB[slug] || "/services";
